import ActivityDrawer from "../../../../parts/activity-drawer/ActivityDrawer";
import SleepTime from "./SleepTime";
import _ from "lodash";
import { isAdminOrOwner } from "../../../../utils/organization-permissions-helpers";

const SleepTimeController = (app) => {
  app.get("/sleep-time", async ({ res, req, locals, load }) => {
    const { query } = req;

    const isAllowToViewAllOrganizationsAthletes = isAdminOrOwner(
      locals.organizationRoleName
    );

    if (
      locals.activeUser.organizationId &&
      isAllowToViewAllOrganizationsAthletes &&
      !locals.allAthletesFromOrganization
    ) {
      await load("allAthletesFromOrganization");
    }

    const { bodycomp } = query;

    let comesFromBodyComp = false;

    if (Boolean(bodycomp) && req?.original?.headers?.referer) {
      comesFromBodyComp =
        req.original.headers.referer.includes("body-composition") ||
        req.original.headers.referer.includes("check-in-summary");
    }
    const modal = _.get(query, "modal", {});
    locals.modal = {
      "activity-feed": <ActivityDrawer />,
    }[modal.type];
    res.body = <SleepTime comesFromBodyComp={comesFromBodyComp} />;
  });
};

export default SleepTimeController;
